<template>
  <v-menu
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        v-model="dateRangeText"
        :label="$t('monitoring.date_range')"
        append-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        class="mt-3"
        dense
        outlined
      />
    </template>
    <v-date-picker v-model="dateRange" range/>
  </v-menu>
</template>
<script>

export default {
  name: 'DateRange',

  data: () => ({ dateRange: [] }),

  mounted () {
    const { startDate, endDate } = this.$route.query
    if (!startDate && !endDate) { this.defineDates() }
  },

  computed: {
    startDate () { return this.$route.query.startDate },
    endDate () { return this.$route.query.endDate },
    dateRangeText () { return `${this.startDate} ${this.$t('monitoring.until')} ${this.endDate || '...'}` }
  },

  methods: {
    defineDates () {
      const dates = [...this.dateRange].sort()
      const startDate = dates[0]
      const endDate = dates[1]
      const query = { ...this.$route.query, startDate, endDate }

      this.$router.replace({ query })
    }
  },

  watch: {
    dateRange: 'defineDates'
  }
}
</script>
